await loadComponent('./components/mc-element.js', false);

class ProductSticky extends McElement {

  connectedCallback() {
    setTimeout(this.setObserver.bind(this));
  }

  setObserver = () => {
    const element = document.querySelector(this.dataset.observe);
    if(!element){
      console.error('ProductSticky: Observer element not found', this.dataset.observe);
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.setActive(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
      });
    });

    this.observer.observe(element);
  }

  setActive = (active) => {
    if(active) this.activate(); else this.deactivate();
  }
}
if (!customElements.get('product-sticky')) {
  customElements.define('product-sticky', ProductSticky);
}

window.ProductSticky = ProductSticky;